export default "__VITE_ASSET__Bc25753X__"